import React from 'react';
import { CtaButton } from './CtaButton';
export function HeroSection() {
  const scrollToOffer = () => {
    const el = document.getElementById('precio-final');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <section className="pt-14 pb-4 md:pt-28 md:pb-14 px-6 max-w-5xl mx-auto text-center" data-id="element-116">
      <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-navy leading-tight mb-6" data-id="element-117">
        ¿Sentís que tu cerebro funciona{' '}
        <span className="italic text-accent" data-id="element-118">"a media máquina"</span>?
      </h1>

      <h2 className="text-xl md:text-2xl font-medium text-navy/80 mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-119">
        Despejá la <strong className="text-navy" data-id="element-120">niebla mental</strong> en{' '}
        <strong className="text-navy" data-id="element-121">3 días</strong> y recuperá la{' '}
        <strong className="text-navy" data-id="element-122">energía</strong> que dabas por perdida
        (mientras tu cuerpo <strong className="text-accent" data-id="element-123">quema grasa</strong>
        ).
      </h2>

      <p className="text-lg text-navy/70 mb-6 md:mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-124">
        Descubrí por qué el{' '}
        <strong className="text-navy" data-id="element-125">cansancio crónico</strong>{' '}
        <strong className="text-navy" data-id="element-126">nada tiene que ver con tu edad</strong>.
        Un método de{' '}
        <span className="text-accent font-semibold" data-id="element-127">reinicio biológico</span>{' '}
        para recuperar el enfoque y la ligereza{' '}
        <strong className="text-navy" data-id="element-128">
          sin contar calorías ni pasar hambre
        </strong>
        .
      </p>

      <CtaButton onClick={scrollToOffer} className="text-2xl" data-id="element-129">
        QUIERO RECUPERAR MI ENERGÍA
      </CtaButton>
    </section>;
}